import axios from 'axios';
import connection from './connection';
import { ItemsDto, ItemResponse, AllItemResponse, ItemsDropDownResponseModel, ItemRequest, ItemsDropDownDto, ItemDetailsResponse, ItemsReqForCategoryId, BomItemRequest, RmBomItemRequest, GetItemForProductRequest, ItemsReqForSubCategoryId, ItemForBrandReq, ItemCodeRequest, TrimsRequest, TrimsMappingRequset, TrimsItemMappingRequest, TrimsConfigurationDTO, SoakStyleResponse,AllSoakStyleResponse, SoakStyleDto, SoakStyleDropDownDto, SoackStyleInfo, SoakStyleRequest } from '@gtpl/shared-models/masters'
import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/production-management';

export class SoakStyleMappingService {

    URL = connection.DEPLOY_URL + '/soaks';

    async createSoaks(soakReq: SoakStyleDto): Promise<SoakStyleResponse> {
     console.log(soakReq,'reqShared');
     
        return await axios.post(this.URL + '/createSoaks', soakReq)
            .then(res => {
                return res.data 
            })
    }
    async getallsoakstyleData(): Promise<AllSoakStyleResponse> {
        return await axios.post(this.URL + '/getallsoakstyleData')
            .then(res => {
                return res.data
            })
    }
    async activateOrDeactivateSoakStyle(soakstyle: SoackStyleInfo): Promise<AllSoakStyleResponse> {
        return await axios.post(this.URL + '/activateOrDeactivateSoakStyle', soakstyle)
            .then(res => {
                return res.data
            })
    }

    async UpdateSoakstyle(): Promise<SoakStyleResponse> {
        return await axios.post(this.URL + '/createSoaks')
            .then(res => {
                return res.data
            })
    }
    
    async getAllDropDownSoakstyle(): Promise<SoakStyleDropDownDto> {
        return await axios.post(this.URL + '/getAllDropDownSoakstyle')
            .then(res => {
                return res.data
            })
    }

    async getSoaksInfoById(): Promise<SoakStyleResponse> {
        return await axios.post(this.URL + '/getSoaksInfoById')
            .then(res => {
                return res.data
            })
    }

    async getAllSoakStyles(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllSoakStyles')
            .then(res => {
                return res.data
            })
    }


    async updateSoaksStyles(soakStyleDto: SoakStyleRequest): Promise<AllSoakStyleResponse> {
        return await axios.post(this.URL + '/UpdateSoakstyle',soakStyleDto)
            .then(res => {
                return res.data
            })
    }
}